import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from './UserContext';
import {getRequestNoParams, postRequest} from './Services/HttpClient'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { setSelectedInput } from './globals'

const Pratyahara = () => {
    const [chartVisible, setChartVisible] = useState(false);
    const [pratyaharaList, setPratyaharaList] = useState([]);
    const [outputData, setOutputData] = useState('');
    const [inputData, setInputData] = useState('');
    const [pratyahara, setPratyahara] = useState('');
    const [pratyaharaChart, setPratyaharaChart] = useState('');
    const { userDetails } = useContext(UserContext);

    const handleInputChange = (event)=>{
      setInputData(event.target.value);
      console.log('target value ' + event.target.value)
      console.log('input value ' + inputData)
    }
    const  handleChange = async () => {
      var input = inputData;
      console.log('input type:', input)
      var result = await postRequest('pratyaharaAppValidate', JSON.stringify({"input": input, "pratyahara": pratyahara}));
      setOutputData(result.data);
    }

  // Define startNewGame before useEffect that references it
  const startNewGame = ()=> {
    setPratyahara(pratyaharaList[Math.floor(Math.random()*pratyaharaList.length)]);
    setInputData('')
  }

    useEffect(() => {
      async function fetchMyAPI() {
        var result = await getRequestNoParams('getPratyaharas');
        var chart = await getRequestNoParams('pratyaharaChart');
        setPratyaharaChart(chart.data)
        setPratyaharaList(result.data);
        setTimeout(()=>{
          startNewGame();
        },0);
      }

      fetchMyAPI()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  const reveal = async ()=> {
    var input = inputData;
    var result = await postRequest('pratyaharaReveal', JSON.stringify({"input": input, "pratyahara": pratyahara}));
    setOutputData(result.data)
  }

  const clear = ()=>{
    setInputData('')
    setOutputData('')
  }

  const onFocus = (evt)=>{
    setSelectedInput((enteredVal, takeAsItIs)=> {
      if(takeAsItIs === true){
        setInputData(enteredVal)
      }else{
        if(inputData !== null && inputData !== undefined && inputData.length > 0){
          console.log('Adding entered value to input ' + inputData);
          setInputData(inputData + ',' + enteredVal);
        }else{
          setInputData(enteredVal);
        }
      }
    });
  }
  const showGuidance = async () =>{
    var result = await getRequestNoParams('pratyaharaGuidance');
    var toDisplay = ''
    result.data.forEach(element => {
      toDisplay = toDisplay + "\n" + element
    });
    setOutputData(toDisplay);    
  }
  const showChart = () =>{
    setChartVisible(true)
  }
  const hideChart = () =>{
    setChartVisible(false)
  }
  const onPratyaharaSelect = (evt)=>{
    setPratyahara(evt.target.value)
    setOutputData('')
  }
 
   return (
    <Container fluid="md">
      <div className="user-details">
        {userDetails.photo && <img src={userDetails.photo} alt="Uploaded" className="uploaded-photo" />}
        {userDetails.name && <span className="user-name">{userDetails.name}</span>}
      </div>
        <row>
          <h4>[Module M3] Pratyahara [अभ्यासः] प्रत्याहारः </h4>
          <span>
           Select
          <select onChange={onPratyaharaSelect}>
            <option value="">Select</option>
            <option value="अक्">अक्</option>
            <option value="अच्">अच्</option>
            <option value="अट्">अट्</option>
            <option value="अण्">अण्</option>
            <option value="अम्">अम्</option>
            <option value="अल्">अल्</option>
            <option value="अश्">अश्</option>
            <option value="इक्">इक्</option>
            <option value="इच्">इच्</option>
            <option value="इण्">इण्</option>
            <option value="उक्">उक्</option>
            <option value="एङ्">एङ्</option>
            <option value="एच्">एच्</option>
            <option value="ऐच्">ऐच्</option>
            <option value="खय्">खय्</option>
            <option value="खर्">खर्</option>
            <option value="ङम्">ङम्</option>
            <option value="चय्">चय्</option>
            <option value="चर्">चर्</option>
            <option value="छव्">छव्</option>
            <option value="जश्">जश्</option>
            <option value="झय्">झय्</option>
            <option value="झर्">झर्</option>
            <option value="झल्">झल्</option>
            <option value="झश्">झश्</option>
            <option value="झष्">झष्</option>
            <option value="बश्">बश्</option>
            <option value="भष्">भष्</option>
            <option value="मय्">मय्</option>
            <option value="यञ्">यञ्</option>
            <option value="यण्">यण्</option>
            <option value="यम्">यम्</option>
            <option value="यय्">यय्</option>
            <option value="यर्">यर्</option>
            <option value="रल्">रल्</option>
            <option value="वल्">वल्</option>
            <option value="शर्">शर्</option>
            <option value="शल्">शल्</option>
            <option value="हल्">हल्</option>
            <option value="हश्">हश्</option>
        </select>
          </span>
        </row>
        <Row>
           <b>Select or type letters for pratyahara : (Add space before next letter) </b>
        </Row>
        <Row >
          <textarea className="pratyaharacontent" name="textarea" onFocus={onFocus} value={inputData} disabled={false} onChange={handleInputChange} />
        </Row>
        <Row className='pratyaharacontent'>
          <input id="display-button" type="submit" value="Submit"  onClick={handleChange} />
          <input id="display-button" type="submit" value="Reveal" onClick={reveal} />
          <input id="display-button" type="submit" value="Clear"  onClick={clear} />
          <a href="https://vedictools.in/files/pratyaharalists.html" target="_blank">Guidance</a>
          <a href="https://vedictools.in/files/pratyaharachart.html" target="_blank">Chart</a> 
        </Row>
        <Row className='pratyahara-output'>
          <div><strong>{outputData}</strong></div>
        </Row>
  </Container>
  );
  };
  
  export default Pratyahara;